"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SubmitLineItem {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
        else {
            this.scoreMaximum = 100;
            this.label = "Title";
            this.resourceId = "tool-assignment-xyz";
            this.tag = "etag";
        }
    }
}
exports.default = SubmitLineItem;
